import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPageCloud: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="page-cloud"><path d="M16.25 15.25C17.364 15.25 18.335 15.8567 18.8525 16.7568C18.9014 16.7537 18.9505 16.75 19 16.75C20.2426 16.75 21.25 17.7574 21.25 19C21.25 20.2426 20.2426 21.25 19 21.25H16.25C14.5931 21.25 13.25 19.9069 13.25 18.25C13.25 16.5931 14.5931 15.25 16.25 15.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M10.75 21.25H4.75V2.75H19.25V12.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPageCloud;
